import { useMutation } from "@tanstack/react-query";
import { message } from "antd";

import sdk from "@/sdk";
import type {
  CorrectCashWithdrawalMutationVariables,
  PreviewBondInterestRecalcMutationVariables,
  CorrectBondInterestMutationVariables,
  CorrectStockPositionMutationVariables,
  PreviewBondInterestRecalcMutation,
} from "@/graphql";

export function useCorrectionForm({
  onSuccess,
}: {
  onSuccess?: () => void;
} = {}) {
  const cashWithdrawal = useMutation({
    mutationFn: (variables: CorrectCashWithdrawalMutationVariables) =>
      sdk.CorrectCashWithdrawal(variables),
    onSuccess: (data) => {
      message.success(
        data.correctCashWithdrawal.message ?? "Амжилттай залруулагдлаа.",
        3
      );
      onSuccess?.();
    },
    onError: (err: any) =>
      message.warning(err.response?.errors?.[0]?.message ?? "Алдаа гарлаа.", 3),
  });

  const bondPreview = useMutation({
    mutationFn: (variables: PreviewBondInterestRecalcMutationVariables) =>
      sdk.PreviewBondInterestRecalc(variables),
    onError: (err: any) =>
      message.warning(err.response?.errors?.[0]?.message ?? "Алдаа гарлаа.", 3),
  });

  const bondCorrection = useMutation({
    mutationFn: (variables: CorrectBondInterestMutationVariables) =>
      sdk.CorrectBondInterest(variables),
    onSuccess: (data) => {
      message.success(
        data.correctBondInterest.message ?? "Амжилттай залруулагдлаа.",
        3
      );
      onSuccess?.();
    },
    onError: (err: any) =>
      message.warning(err.response?.errors?.[0]?.message ?? "Алдаа гарлаа.", 3),
  });

  const stockCorrection = useMutation({
    mutationFn: (variables: CorrectStockPositionMutationVariables) =>
      sdk.CorrectStockPosition(variables),
    onSuccess: (data) => {
      message.success(
        data.correctStockPosition.message ?? "Амжилттай залруулагдлаа.",
        3
      );
      onSuccess?.();
    },
    onError: (err: any) =>
      message.warning(err.response?.errors?.[0]?.message ?? "Алдаа гарлаа.", 3),
  });

  return {
    cashWithdrawal,
    bondPreview,
    bondCorrection,
    stockCorrection,
  };
}
